import { serviceMaker, methods, api } from "./index.js";

export const taxListApi = () => serviceMaker(`/tax`, methods.GET, api.NGB);

export const createTax = (data) =>
  serviceMaker(`/tax`, methods.POST, api.NGB, data);

export const deleteTaxApi = (id) =>
  serviceMaker(`/tax/${id}`, methods.DELETE, api.NGB);

export const addJurisdiction = (payload) =>
  serviceMaker(`/taxregion`, methods.POST, api.NGB, payload);

export const getTaxRegion = (id) =>
  serviceMaker(`/taxregion/${id}`, methods.GET, api.NGB);

export const removeTaxRegion = (id) =>
  serviceMaker(`/taxregion/${id}`, methods.DELETE, api.NGB);

export const taxInfoByid = (id) =>
  serviceMaker(`/tax/${id}`, methods.GET, api.NGB);

export const taxUpdate = (data, id) =>
  serviceMaker(`/tax/${id}`, methods.PUT, api.NGB, data);

export const taxTemplate = () =>
  serviceMaker(`/tax/template`, methods.GET, api.NGB);

export const taxMappingTemplate = (chargeCode) =>
  serviceMaker(
    `taxmap/template?chargeCode=${chargeCode}`,
    methods.GET,
    api.NGB
  );
